<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'WifiMasterList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Wifi Master
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Wifi Master</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="WifiMaster">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools"></div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div v-if="$organizationId == 1" class="form-group required">
                    <label class="control-label">Audra Name</label>

                    <multiselect
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('accountId')"
                    >
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="w-full p-10">
                    <h4 class="card-common-title p-0 mb-2">2.4 GHZ Device</h4>

                    <div class="form-row align-items-end">
                      <div class="form-group col-md-3">
                        <!-- <label class="control-label">Options</label>
                        <select
                          class="form-control"
                          style="width: 100%"
                          name="2ghzoptions"
                          v-model="value['2ghzoptions']"
                          id="2ghzoptions"
                        >
                          <option value="1">Enabled</option>
                          <option value="0">Disabled</option>
                        </select> -->
                        <div class="d-flex align-items-center">
                          <div class="switch-row">
                            <label class="switch-label">Options Enabled</label>
                          </div>
                          <label class="switch ml-auto">
                            <input
                              type="checkbox"
                              name="2ghzoptions"
                              v-model="value['2ghzoptions']"
                              id="2ghzoptions"
                              value="1"
                            />
                            <div class="slider round"></div>
                          </label>
                        </div>
                      </div>

                      <div class="form-group col-md-3">
                        <label class="control-label">Channel Number</label>
                        <multiselect
                          v-model="value['2ghzchannelNumber']"
                          :options="pre.channelNumbers"
                          placeholder="Select Channel Number"
                          :searchable="true"
                          :multiple="false"
                          id="2ghzchannelNumber"
                          v-bind:class="{
                            'has-error': errors.has('2ghzchannelNumber'),
                          }"
                          name="2ghzchannelNumber"
                        >
                        </multiselect>
                      </div>

                      <div class="form-group col-md-3">
                        <label class="control-label">Channel Width</label>
                        <multiselect
                          v-model="value['2ghzbandwidth']"
                          :options="Object.keys(pre.channelWidths)"
                          :custom-label="(opt) => pre.channelWidths[opt]"
                          placeholder="Select Channel Width"
                          :searchable="true"
                          :multiple="false"
                          id="2ghzbandwidth"
                          v-bind:class="{
                            'has-error': errors.has('2ghzbandwidth'),
                          }"
                          name="2ghzbandwidth"
                        >
                        </multiselect>
                      </div>

                      <div class="form-group col-md-3">
                        <label class="control-label">HW Mode</label>
                        <multiselect
                          v-model="value['2ghzhw_mode']"
                          :options="Object.keys(pre.hwMode)"
                          :custom-label="(opt) => pre.hwMode[opt]"
                          placeholder="Select Channel Width"
                          :searchable="true"
                          :multiple="false"
                          id="2ghzhw_mode"
                          v-bind:class="{
                            'has-error': errors.has('2ghzhw_mode'),
                          }"
                          name="2ghzhw_mode"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="w-full mt-4 p-10">
                    <h4 class="card-common-title p-0 mb-2">
                      2.4 GHZ Interface
                    </h4>
                    <div
                      v-for="(wifiTwoghzDetail, index) in wifiTwoghzDetails"
                      :key="index"
                      class=""
                    >
                      <div class="form-row">
                        <div class="form-group col-sm">
                          <label class="col-form-label" for="wifiName"
                            >Network Name</label
                          >
                          <input
                            autocomplete="off"
                            type="text"
                            v-validate="{
                              required: true,
                              regex: /^[a-zA-Z0-9_]*$/,
                            }"
                            id="wifiName"
                            name="wifiName"
                            v-model="wifiTwoghzDetail.wifiName"
                            :class="{ 'has-error': errors.has('wifiName') }"
                            class="form-control"
                            placeholder="Input Network Name"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('wifiName')"
                          >
                            {{ errors.first("wifiName") }}
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="col-form-label">Security Modes</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="wifiTwoghzDetail.security"
                            :options="Object.keys(pre.securityModes)"
                            :custom-label="(opt) => pre.securityModes[opt]"
                            placeholder="Select Security Modes"
                            :searchable="true"
                            :multiple="false"
                            id="security"
                            v-bind:class="{
                              'has-error': errors.has('security'),
                            }"
                            name="security"
                          >
                          </multiselect>
                          <div
                            class="help text-danger"
                            v-show="errors.has('security')"
                          >
                            {{ errors.first("security") }}
                          </div>
                        </div>

                        <div
                          class="form-group col-sm"
                          v-if="
                            wifiTwoghzDetail &&
                            (wifiTwoghzDetail.security === 'psk' ||
                              wifiTwoghzDetail.security === 'psk2')
                          "
                        >
                          <label class="col-form-label" for="password"
                            >Password</label
                          >

                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="fas fa-eye-slash"></i>
                              </span>
                            </div>
                            <input
                              autocomplete="off"
                              type="text"
                              id="password"
                              name="password"
                              v-model="wifiTwoghzDetail.password"
                              :class="{ 'has-error': errors.has('password') }"
                              class="form-control"
                              placeholder="Input Password"
                            />
                          </div>
                        </div>

                        <div class="form-group col-sm">
                          <label class="col-form-label">Auto Roaming</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="''"
                            v-model="wifiTwoghzDetail.auto_roaming || 0"
                            :options="Object.keys(pre.autoroamingOptionList)"
                            :custom-label="
                              (opt) => pre.autoroamingOptionList[opt]
                            "
                            placeholder="Select Auto Roaming"
                            :searchable="true"
                            :multiple="false"
                            id="auto_roaming"
                            v-bind:class="{
                              'has-error': errors.has('auto_roaming'),
                            }"
                            name="auto_roaming"
                          >
                          </multiselect>
                          <div
                            class="help text-danger"
                            v-show="errors.has('auto_roaming')"
                          >
                            {{ errors.first("auto_roaming") }}
                          </div>
                        </div>

                        <div
                          class="form-group col-sm"
                          v-if="wifiTwoghzDetail.auto_roaming == 1"
                        >
                          <label class="col-form-label" for="mobility_domain"
                            >Mobility Domain</label
                          >

                          <div class="input-group form-row">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="fas fa-eye-slash"></i>
                              </span>
                            </div>
                            <input
                              autocomplete="off"
                              type="text"
                              id="mobility_domain"
                              name="mobility_domain"
                              v-model="wifiTwoghzDetail.mobility_domain"
                              :class="{
                                'has-error': errors.has('mobility_domain'),
                              }"
                              class="form-control"
                              placeholder="Input mobility_domain"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-end border-bottom pb-3 mb-3"
                      >
                        <a
                          class="text-danger fw-500"
                          @click="remove2GHZInterface(index)"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>
                    <div class="form-group text-right">
                      <a @click.prevent="add2GHZInterface()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>

                  <div class="w-full p-10">
                    <h4 class="card-common-title p-0 mb-2">5 GHZ Device</h4>
                    <div class="form-row align-items-end">
                      <div class="form-group col-md-3">
                        <!-- <label class="control-label">Options</label>
                        <select
                          class="form-control"
                          style="width: 100%"
                          name="5ghzoptions"
                          v-model="value['5ghzoptions']"
                          id="5ghzoptions"
                        >
                          <option value="1">Enabled</option>
                          <option value="0">Disabled</option>
                        </select> -->

                        <div class="d-flex align-items-center mb-1">
                          <div class="switch-row">
                            <label class="switch-label">Options Enabled</label>
                          </div>
                          <label class="switch ml-auto">
                            <input
                              type="checkbox"
                              name="5ghzoptions"
                              v-model="value['5ghzoptions']"
                              id="5ghzoptions"
                              value="1"
                            />
                            <div class="slider round"></div>
                          </label>
                        </div>
                      </div>

                      <div class="form-group col-md-3">
                        <label class="control-label">Channel Number</label>
                        <multiselect
                          v-model="value['5ghzchannelNumber']"
                          :options="pre.channelNumbers"
                          placeholder="Select Channel Number"
                          :searchable="true"
                          :multiple="false"
                          id="5ghzchannelNumber"
                          v-bind:class="{
                            'has-error': errors.has('5ghzchannelNumber'),
                          }"
                          name="5ghzchannelNumber"
                        >
                        </multiselect>
                      </div>

                      <div class="form-group col-md-3">
                        <label class="control-label">Channel Width</label>
                        <multiselect
                          v-model="value['5ghzbandwidth']"
                          :options="Object.keys(pre.channelWidths)"
                          :custom-label="(opt) => pre.channelWidths[opt]"
                          placeholder="Select Channel Width"
                          :searchable="true"
                          :multiple="false"
                          id="5ghzbandwidth"
                          v-bind:class="{
                            'has-error': errors.has('5ghzbandwidth'),
                          }"
                          name="5ghzbandwidth"
                        >
                        </multiselect>
                      </div>

                      <div class="form-group col-md-3">
                        <label class="control-label">HW Mode</label>
                        <multiselect
                          v-model="value['2ghzhw_mode']"
                          :options="Object.keys(pre.hwMode)"
                          :custom-label="(opt) => pre.hwMode[opt]"
                          placeholder="Select Channel Width"
                          :searchable="true"
                          :multiple="false"
                          id="2ghzhw_mode"
                          v-bind:class="{
                            'has-error': errors.has('2ghzhw_mode'),
                          }"
                          name="2ghzhw_mode"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="w-full mt-3 p-10">
                    <h4 class="card-common-title p-0 mb-2">5 GHZ Interface</h4>
                    <div
                      v-for="(wifiFiveghzDetail, index) in wifiFiveghzDetails"
                      :key="index"
                      class="form-row"
                    >
                      <div class="form-group required col-sm">
                        <label class="col-form-label" for="wifiName"
                          >Network Name</label
                        >
                        <input
                          autocomplete="off"
                          type="text"
                          id="wifiName"
                          v-validate="'required'"
                          name="wifiName"
                          v-model="wifiFiveghzDetail.wifiName"
                          v-bind:class="{
                            'has-error': errors.has('wifiName'),
                          }"
                          class="form-control"
                          placeholder="Input Network Name"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('wifiName')"
                        >
                          {{ errors.first("wifiName") }}
                        </div>
                      </div>

                      <div class="form-group col-sm">
                        <label class="col-form-label">Security Modes</label>
                        <multiselect
                          :select-label="''"
                          :deselect-label="''"
                          v-model="wifiFiveghzDetail.security"
                          :options="Object.keys(pre.securityModes)"
                          :custom-label="(opt) => pre.securityModes[opt]"
                          placeholder="Select Security Modes"
                          :searchable="true"
                          :multiple="false"
                          id="security"
                          v-bind:class="{ 'has-error': errors.has('security') }"
                          name="security"
                        >
                        </multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('security')"
                        >
                          {{ errors.first("security") }}
                        </div>
                      </div>

                      <div
                        class="form-group col-sm"
                        v-if="
                          wifiFiveghzDetail &&
                          (wifiFiveghzDetail.security === 'psk' ||
                            wifiFiveghzDetail.security === 'psk2')
                        "
                      >
                        <label class="col-form-label" for="password"
                          >Password</label
                        >

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="fas fa-eye-slash"></i>
                            </span>
                          </div>
                          <input
                            autocomplete="off"
                            type="text"
                            id="password"
                            name="password"
                            v-model="wifiFiveghzDetail.password"
                            :class="{ 'has-error': errors.has('password') }"
                            class="form-control"
                            placeholder="Input Password"
                          />
                        </div>
                      </div>

                      <div class="form-group col-sm">
                        <label class="col-form-label">Auto Roaming</label>
                        <multiselect
                          :select-label="''"
                          :deselect-label="''"
                          v-model="wifiFiveghzDetail.auto_roaming || 0"
                          :options="Object.keys(pre.autoroamingOptionList)"
                          :custom-label="
                            (opt) => pre.autoroamingOptionList[opt]
                          "
                          placeholder="Select Auto Roaming"
                          :searchable="true"
                          :multiple="false"
                          id="auto_roaming"
                          v-bind:class="{
                            'has-error': errors.has('auto_roaming'),
                          }"
                          name="auto_roaming"
                        >
                        </multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('auto_roaming')"
                        >
                          {{ errors.first("auto_roaming") }}
                        </div>
                      </div>

                      <div
                        class="form-group col-sm"
                        v-if="wifiFiveghzDetail.auto_roaming == 1"
                      >
                        <label class="col-form-label" for="mobility_domain"
                          >Mobility Domain</label
                        >

                        <div class="input-group form-row">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="fas fa-eye-slash"></i>
                            </span>
                          </div>
                          <input
                            autocomplete="off"
                            type="text"
                            id="mobility_domain"
                            name="mobility_domain"
                            v-model="wifiFiveghzDetail.mobility_domain"
                            :class="{
                              'has-error': errors.has('mobility_domain'),
                            }"
                            class="form-control"
                            placeholder="Input mobility_domain"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-end border-bottom pb-3 mb-3"
                    >
                      <a
                        class="text-danger fw-500"
                        @click="remove5GHZInterface(index)"
                      >
                        <i class="icon-trash"></i> Remove
                      </a>
                    </div>
                    <div class="form-group text-right">
                      <a @click.prevent="add5GHZInterface()" class="pc fw-500">
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-3">
              <!-- <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button> -->
              <button
                type="button"
                @click.prevent="handleSubmission()"
                v-if="!is_edit"
                class="btn"
              >
                Submit
              </button>
              <button
                type="button"
                @click.prevent="handleSubmission()"
                v-if="is_edit"
                class="btn"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "WifiMasterForm",
  metaInfo: {
    title: "Wifi Master | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      audraName: [],
      channelNumbers: ["Auto", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      channelWidths: { 20: "20MHz", 40: "40MHz", 80: "80MHz" },
      securityModes: { none: "Open (risky)", psk: "WPA-PSK", psk2: "WPA2-PSK" },
      hwMode: { "11n": "802.11n", "11bgn": "802.11b/g/n" },
      autoroamingOptionList: { 0: "NO", 1: "YES" },
    },
    wifiTwoghzDetails: [],
    wifiFiveghzDetails: [],
  }),
  methods: {
    // handleSubmission () {
    //   let _this = this
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       _this.is_loading = true
    //       let api_url = '/wifi_masters'
    //       let method = 'POST'
    //       if (_this.is_edit) {
    //         api_url = '/wifi_masters/' + _this.$route.params.id
    //         method = 'PUT'
    //       }

    //       axios({
    //         method: method,
    //         url: api_url,
    //         data: _this.value,
    //         headers: { 'Content-Type': 'application/json' }
    //       })
    //         .then(function (response) {
    //           _this.$toaster.success(response.data.message)
    //           _this.$router.push({ name: 'WifiMasterList' })
    //         })
    //         .catch(errors => {
    //           if (errors.response.status === 501) {
    //             _this.$toaster.error(errors.response.data.errors.message)
    //             _this.$setErrorsFromResponse(errors.response.data.errors)
    //           } else if (errors.response.data) {
    //             _this.$toaster.error(errors.response.data.message)
    //             _this.$setErrorsFromResponse(errors.response.data)
    //           }
    //         })
    //         .finally(() => {
    //           _this.is_loading = false
    //         })
    //     }
    //   })
    // },
    handleSubmission() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Check if there are enough interfaces
          if (
            this.wifiTwoghzDetails.length < 1 ||
            this.wifiFiveghzDetails.length < 1
          ) {
            this.$toaster.error(
              "At least one interface for each band is required"
            );
            return; // Prevent further execution
          }

          this.is_loading = true;
          let api_url = "/wifi_masters";
          let method = "POST";

          if (this.is_edit) {
            api_url = "/wifi_masters/" + this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then((response) => {
              this.$toaster.success(response.data.message);
              this.$router.push({ name: "WifiMasterList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                this.$toaster.error(errors.response.data.errors.message);
                this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                this.$toaster.error(errors.response.data.message);
                this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/wifi_masters/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            console.log(response.data);
            this.wifiFiveghzDetails = this.value.wifi_fiveghz_details;
            // console.log(this.wifiFiveghzDetails)
            this.wifiTwoghzDetails = this.value.wifi_twoghz_details;
          })
          .catch((error) => {
            console.log(error.response);
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    add2GHZInterface() {
      this.wifiTwoghzDetails.push({
        wifiName: "",
        security: "none",
        password: "",
        auto_roaming: "",
        mobility_domain: "",
      });
    },

    remove2GHZInterface(index) {
      this.wifiTwoghzDetails.splice(index, 1);
    },

    remove5GHZInterface(index) {
      this.wifiFiveghzDetails.splice(index, 1);
    },

    add5GHZInterface() {
      this.wifiFiveghzDetails.push({
        wifiName: "",
        security: "none",
        password: "",
        auto_roaming: "",
        mobility_domain: "",
      });
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
